import * as server from '../entries/pages/_page.server.ts.js';

export const index = 2;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/+page.server.ts";
export const imports = ["_app/immutable/nodes/2.Bp7JE7Pz.js","_app/immutable/chunks/kCE9wz0g.js","_app/immutable/chunks/x-hq5fDG.js","_app/immutable/chunks/B1veta3r.js","_app/immutable/chunks/C6KhNEX3.js","_app/immutable/chunks/BZ4lcC0v.js","_app/immutable/chunks/DIljKPJN.js","_app/immutable/chunks/Bu7F9NOv.js"];
export const stylesheets = ["_app/immutable/assets/AppShell.CDPwj3zU.css","_app/immutable/assets/2.DaTmt6o7.css"];
export const fonts = [];
